import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { AdminSidebar } from './admin-sidebar.js';

export interface AdminMobileNavigationProps {
  open: boolean;
  onClose: () => void;
}

/** The mobile drawer -- same AdminSidebar content, a full-screen accessible dialog rather than a fixed rail. Closes on Escape or backdrop click, same pattern as AdminConfirmDialog. */
export function AdminMobileNavigation({ open, onClose }: AdminMobileNavigationProps) {
  useEffect(() => {
    if (!open) return;
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-40 flex lg:hidden">
      <div className="fixed inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Admin navigation"
        className="relative flex h-full w-72 max-w-[85vw] flex-col bg-white shadow-xl"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close navigation"
          className="focus-visible:ring-brand absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
        <AdminSidebar onNavigate={onClose} />
      </div>
    </div>,
    document.body,
  );
}
